import * as RemoteObject from '../lib/RemoteObject.js'

export async function controllerDirective(
  node: Node,
  { expression }: { expression: string },
  { cleanup }: { cleanup: (fn: () => void) => void }
) {
  if (node.nodeType !== Node.ELEMENT_NODE || node.nodeName !== 'TEMPLATE')
    throw new Error('x-controller may only be used on template tags')

  const el = node as HTMLTemplateElement
  let remoteObjectUrl: string = expression
  if (!expression) {
    const closestStageEl = el.closest('cnc-stage[href],cnc-block[href]')
    let url: URL | Location = window.location

    if (closestStageEl) {
      const stageHref = closestStageEl.getAttribute('href')!
      if (stageHref.match(/^https?:\/\//)) {
        url = new URL(stageHref)
      } else {
        url = new URL(`${window.location.protocol}//${window.location.host}${stageHref}`)
      }
    } else {
      url = new URL(window.location.toString())
    }

    remoteObjectUrl = `${url.protocol}//${url.host}${url.pathname}`
    if (url.pathname.endsWith('/')) {
      remoteObjectUrl += 'index'
    }
    if (!remoteObjectUrl.match(/[.].mjs$}/)) {
      remoteObjectUrl += '.mjs'
    }

    // if (url.search) {
    //   remoteObjectUrl += `?${url.search}`
    // }
  }

  if (window.location.search) {
    if (remoteObjectUrl.includes('?')) {
      remoteObjectUrl += '&' + window.location.search
    } else {
      remoteObjectUrl += '?' + window.location.search
    }
  }

  const remoteObject = await RemoteObject.connect(remoteObjectUrl)
  remoteObject.controllerUrl = remoteObjectUrl
  const reactiveObject = Alpine.reactive(remoteObject)

  let insertedChildren: (HTMLElement | Node)[] = []
  if (el.parentElement?.tagName === 'BODY') {
    // all children will inherit this
    Alpine.addScopeToNode(document.body, reactiveObject)

    Array.from(el.content.childNodes).map((child) => {
      const newChild = child.cloneNode(true)
      if (el.parentElement) {
        el.parentElement.insertBefore(newChild, el)
        insertedChildren.push(newChild)
      }
      return newChild
    })
  } else {
    Array.from(el.content.childNodes).map((child) => {
      const newChild = child.cloneNode(true)
      console.log('installing x-controller child', newChild)
      Alpine.mutateDom(() => {
        el.parentElement?.insertBefore(newChild, el)
      })
      Alpine.addScopeToNode(newChild as HTMLElement, reactiveObject)
      Alpine.nextTick(() => {
        Alpine.initTree(newChild as HTMLElement)
      })
      insertedChildren.push(newChild)
      return newChild
    })
  }

  const firstInsertedChild = insertedChildren.find((c) => c.nodeType === Node.ELEMENT_NODE)!

  if (remoteObject.init) {
    // because el is a template, we need to run this in the context of a node that's been added
    Alpine.evaluate(firstInsertedChild as HTMLElement, 'init()')
  }

  cleanup(() => {
    if (remoteObject.destroy) {
      Alpine.evaluate(firstInsertedChild as HTMLElement, 'destroy()')
    }

    Alpine.nextTick(() => {
      insertedChildren.forEach((childEl) => {
        // @ts-ignore
        // insertedEl._x_cleanups?.forEach((f) => f())
        childEl?._x_cleanups?.forEach((f) => f())
        // @ts-ignore
        childEl?.remove()
      })
    })
  })
}
